import { Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Breadcrumb, useLocalization } from '@ui-framework/index';
import { IconLibrary, Layout, PageSection } from '@product-framework/index';
import { MY_NOTIFICATION_PREFERENCES_API_PATH } from '../../apiPaths';
import NotificationPreferencesForm from '../../components/NotificationPreferencesForm';

function NotificationPreferencesPage() {
  const { formatMessage } = useLocalization();
  const navigate = useNavigate();
  const breadCrumb = [
    {
      name: formatMessage({
        id: 'DASHBOARD',
        defaultMessage: 'Dashboard',
      }),
      icon: IconLibrary.Dashboard,
      onClick: () => navigate('/dashboard'),
    },
    {
      name: formatMessage({
        id: 'NOTIFICATIONS',
        defaultMessage: 'Notifications',
      }),
      icon: IconLibrary.Alerts,
      onClick: () => navigate('/notifications'),
    },
    {
      name: formatMessage({
        id: 'MY_NOTIFICATION_PREFERENCES',
        defaultMessage: 'My Notification Preferences',
      }),
      icon: IconLibrary.NotificationPreferences,
      onClick: undefined,
    },
  ];

  return (
    <Layout>
      <Breadcrumb items={breadCrumb} />
      <PageSection
        label={formatMessage({
          id: 'MY_NOTIFICATION_PREFERENCES',
          defaultMessage: 'My Notification Preferences',
        })}>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          {formatMessage({
            id: 'NOTIFICATION_PREFERENCES_DESCRIPTION',
            defaultMessage:
              'Choose how you would like to be told when something needs you.',
          })}
        </Typography>
        <NotificationPreferencesForm
          apiPath={MY_NOTIFICATION_PREFERENCES_API_PATH}
        />
      </PageSection>
    </Layout>
  );
}

export default NotificationPreferencesPage;
